import { Auditable, QueryParams, SortParams } from "..";

export interface SurgerySchedulerSurgeon extends Auditable {
    surgerySchedulerId: number;
    surgeonId: number;
    surgerySchedulerFirstName: string;
    surgerySchedulerLastName: string;
    surgeonFirstName: string;
    surgeonLastName: string;
}

export interface SurgerySchedulerSurgeonRequest {
    surgerySchedulerId: number;
    surgeonId: number;
}


export const DefaultSurgerySchedulerSurgeonQueryParams: QueryParams = {
    firstName: "",
    lastName: "",
};

export const DefaultSurgerySchedulerSurgeonSortParams: SortParams = {
    orderBy: "firstName",
    orderDesc: "false",
};
